import { useAuthContext } from 'HOC/withAuth';
import { AuthContext, MembershipFeatureFlags } from '../shared/typesTS';

export const useMembershipFeatureFlag = <T extends keyof MembershipFeatureFlags>(
  ...args: Array<T>
) => {
  const { user } = useAuthContext() as AuthContext;
  return args.map((featureFlag) => user?.membership?.features?.[featureFlag] ?? false);
};
